<template>
    <app-dialog v-model="showModal" size="sm" @close="onClose">
        <template #header>
            <h3 class="text-xl font-bold text-theme-base">
                Antes de irte: tu catálogo puede ser gratis
            </h3>
        </template>
        <div class="flex flex-col gap-3 text-sm text-theme-base">
            <p>
                Al terminar eliges tu plan: puedes quedarte con el plan gratis o
                probar Pro sin pagar. No te pedimos tarjeta.
            </p>
            <p v-if="remainingSteps > 0" class="text-theme-muted">
                Te {{ remainingSteps === 1 ? "falta" : "faltan" }}
                {{ remainingSteps }}
                {{ remainingSteps === 1 ? "paso" : "pasos" }} para llegar.
            </p>
            <p v-else class="text-theme-muted">
                Las opciones gratis están al inicio de esta página.
            </p>
        </div>
        <template #footer>
            <app-button color="brand-blue" class="w-full" @click="keepGoing">
                Seguir creando mi catálogo
            </app-button>
        </template>
    </app-dialog>
</template>

<script>
import { ONBOARDING_EXIT_INTENT_STORAGE_KEY } from "@/common/constants";

import AppDialog from "@/components/utils/AppDialog.vue";

// Avisa antes de que alguien abandone el onboarding sin haber visto que
// puede empezar gratis: modal propio cuando el mouse sale hacia las
// pestañas (solo computador, una vez por sesión) y el aviso nativo del
// navegador al cerrar/recargar (su texto no se puede personalizar).
export default {
    name: "OnboardingExitGuard",

    components: { AppDialog },

    props: {
        active: {
            type: Boolean,
            default: false
        },
        step: {
            type: String,
            default: ""
        },
        remainingSteps: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            showModal: false,
            released: false
        };
    },

    mounted() {
        window.addEventListener("beforeunload", this.onBeforeUnload);
        document.addEventListener("mouseout", this.onMouseOut);
    },

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
        document.removeEventListener("mouseout", this.onMouseOut);
    },

    methods: {
        // Para salidas intencionales (cerrar sesión): el handler lee este
        // flag en el momento del evento, sin esperar a que `active` se
        // propague en el siguiente render.
        release() {
            this.released = true;
        },

        isGuarding() {
            return this.active && !this.released;
        },

        onBeforeUnload(event) {
            if (!this.isGuarding()) return;
            event.preventDefault();
            event.returnValue = "";
        },

        onMouseOut(event) {
            if (!this.isGuarding() || this.showModal) return;
            if (event.relatedTarget || event.clientY > 0) return;
            if (!window.matchMedia("(pointer: fine)").matches) return;
            if (this.alreadyShown()) return;
            this.markShown();
            this.showModal = true;
            this.$analytics.trackEvent("onboarding_exit_intent_shown", {
                step: this.step,
                remaining_steps: this.remainingSteps
            });
        },

        keepGoing() {
            this.$analytics.trackEvent("onboarding_exit_intent_continue", {
                step: this.step
            });
            this.showModal = false;
        },

        onClose() {
            this.showModal = false;
        },

        alreadyShown() {
            try {
                return Boolean(
                    sessionStorage.getItem(ONBOARDING_EXIT_INTENT_STORAGE_KEY)
                );
            } catch {
                return false;
            }
        },

        markShown() {
            try {
                sessionStorage.setItem(ONBOARDING_EXIT_INTENT_STORAGE_KEY, "1");
            } catch {
                // Sin storage se puede volver a mostrar; no es grave.
            }
        }
    }
};
</script>
